import React from 'react'

const Loading = () => {
  return (
    <div className='loader'>Now Connecting ...</div>
  )
}

export default Loading